import React, {Component} from 'react';
import {X} from "react-feather";
import {renderRoutes} from 'react-router-config';
import Helmet from 'react-helmet';

import DefaultLayout from '../../../Layout/DefaultLayout.jsx';
import FreelanceMenu from '../FreelanceMenu/FreelanceMenu.jsx'
import {withRouter} from "react-router-dom";

import conf from "../../../../../shared/conf.js";
import LeftMenuEdit from "../LeftMenu/LeftMenuEdit.jsx";

import FreelancePageWrapper from "../../../../../shared/components/Styled/Containers/FreelancePageWrapper.jsx";
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx";
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx";

import './EditFreelance.scss'

class EditFreelance extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hideMobileMenu: true,
    }
  }

  componentDidMount() {
    this.scrollToHash()
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.scrollToHash()
    }, 500)
  }

  scrollToHash = () => {
    const hash = window.location.hash
    if(!hash) {
      return
    }

    const elem = document.getElementById(hash.replace('#', ''))
    if(!elem) {
      return
    }

    elem.scrollIntoView({ behavior: "smooth", block: "start"})
  }

  render() {
    const {owner, profile, currentUser, onFormSuccess, submit, refresh, route} = this.props;
    const isFreelanceAccount = !!(currentUser && currentUser.account_type === conf.accountTypes.freelance)

    const helmet = <Helmet>
      <title>Éditer mon profil</title>
    </Helmet>;

    return (
      <DefaultLayout id="edit-freelance-body" className="edit-freelance" helmet={helmet}>
        <div className="page-background print-no-color" onClick={(e) => {
          if (!this.state.hideMobileMenu){
            this.setState({hideMobileMenu: true})
          }
        }}>
          <div className="container">
            {isFreelanceAccount ?
              <div style={{display: "flex", gap: '20px'}} className="py-5">
                <div
                  className={`freelance-menu-mobile ${this.state.hideMobileMenu ? 'hide': ''}`}
                >
                  <CardRow justify='flex-end'><CardCol> <X/> </CardCol></CardRow>
                  <FreelanceMenu
                    freelance={currentUser}
                    isMobile={true}
                    link={{
                      menu: 'edit-freelance'
                    }}/>
                </div>
                <div
                  className="freelance-menu-column"
                >
                  <FreelanceMenu
                    freelance={currentUser}
                    link={{
                      menu: 'edit-freelance'
                    }}/>
                </div>

                <div style={{flex: "auto"}}>
                  <FreelancePageWrapper
                    onMobileCtaClick={() => {this.setState({hideMobileMenu: false})}}>
                    {renderRoutes(route.routes, {
                      edit: true,
                      user: profile.user,
                      freelance: profile.freelance,
                      owner,
                      submit,
                      refresh,
                      onFormSuccess,
                    })}
                  </FreelancePageWrapper>
                </div>
              </div>
              :
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="edit-freelance-left">
                    <div className="py-5">
                      <LeftMenuEdit
                        link={{
                          menu: 'edit-freelance'
                        }}
                        freelance={profile.freelance}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-9 col-lg-10">
                  <div className="px-xxl-5 px-0 py-5">
                    {renderRoutes(route.routes, {
                      edit: true,
                      user: profile.user,
                      freelance: profile.freelance,
                      currentUser,
                      owner,
                      submit,
                      refresh,
                      onFormSuccess,
                    })}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </DefaultLayout>
    );
  }
}

export default withRouter(EditFreelance);